import api from "../../utils/Api";
import {
    PAYMENT_DETAILS_SHARE_VIA_EMAIL_REQUEST,
    PAYMENT_DETAILS_SHARE_VIA_EMAIL_SUCCESS,
    PAYMENT_DETAILS_SHARE_VIA_EMAIL_ERROR,
} from "./PaymentShareViaEmailTypes";

export const paymentDetailsShareViaEmailRequest = () => {
    return {
        type: PAYMENT_DETAILS_SHARE_VIA_EMAIL_REQUEST,
    };
};

export const paymentDetailsShareViaEmailSuccess = (paymentDetails) => {
    return {
        type: PAYMENT_DETAILS_SHARE_VIA_EMAIL_SUCCESS,
        payload: paymentDetails,
    };
};

export const paymentDetailsShareViaEmailFailure = (error) => {
    return {
        type: PAYMENT_DETAILS_SHARE_VIA_EMAIL_ERROR,
        payload: error,
    };
};

export const paymentDetailsShareViaEmail = (payment_id) => {

    const payload = {
        payment_id: payment_id,
    };
    const headers = {
        Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    return async (dispatch) => {
        dispatch(paymentDetailsShareViaEmailRequest());
        try {
            const response = await api.post("payment/detail/shareViaEmail", payload, {
                headers: headers,
            });
            const paymentDetailsShareViaEmailData = response.data.payment;
            dispatch(paymentDetailsShareViaEmailSuccess(paymentDetailsShareViaEmailData));
        } catch (error) {
            console.log("Redux error - ", error.response.data.message);
            const errorMsg = error.response.data.message;
            dispatch(paymentDetailsShareViaEmailFailure(errorMsg));
        }
    };
};
